export type ChildSeatTypeEnum = 'MLIT' | 'FMVSS' | 'ECE' | 'CARES';
export const ChildSeatTypeEnum = {
  Mlit: 'MLIT' as ChildSeatTypeEnum,
  Fmvss: 'FMVSS' as ChildSeatTypeEnum,
  Ece: 'ECE' as ChildSeatTypeEnum,
  Cares: 'CARES' as ChildSeatTypeEnum,
};
